var order = {
    init: function() {
        var self = this;
        var active = '';

        if( jQuery('.wpcf7-form-control-wrap[data-name="pobocka"]').length ) {
            jQuery('input[type=radio][name=pobocka]').change(function() {
                console.log(this.value);
                active = jQuery('p[data-pobocka="'+ this.value +'"]');
                self.setActive( active );  
            });
    
            if( tabActive != 'none' ) {
                active = jQuery('p[data-pobocka="'+ tabActive +'"]');
                self.setActive( active );
    
                setTimeout(() => {
                    jQuery('input[name="pobocka"][value="'+ tabActive +'"]').prop('checked', true);
                }, 250);
            }
        }

        $( '.wpcf7-form' ).each( function() {
            var $form = $( this ),
            $submit = $form.find( '.wpcf7-submit' ),
            $wpcf7 = $form.closest( 'div.wpcf7' )[0];

            $wpcf7.addEventListener( 'wpcf7mailsent', function( event ) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push( {
                    'event': 'order_submit'
                } );
            }, false );
        } );
    },
    setActive: function(active) {
        jQuery('.cf7-pobocka-adresa p.active').removeClass('active');
        
        active.addClass('active');
        jQuery('input[name="where-send"]').val( active.attr( 'data-where-send' ) );
    }
};

export { order };